"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BathroomInfoCollapseWidget = void 0;
var React = require("react");
var CollapseHtmlWithInfoIconWidget_1 = require("../../../components/CollapseHtmlWithInfoIconWidget");
var BathroomInfoCollapseWidget = /** @class */ (function (_super) {
    __extends(BathroomInfoCollapseWidget, _super);
    function BathroomInfoCollapseWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.bathroomInfoCallback = function (infoState) {
            _this.setState({ showBathroomInfo: infoState });
        };
        _this.state = {
            showBathroomInfo: false
        };
        return _this;
    }
    BathroomInfoCollapseWidget.prototype.render = function () {
        return (React.createElement("div", { className: this.state.showBathroomInfo ? "background-color-grey inner-content negative-margin" : "" }, this.bathroomInfoCollapseLabel()));
    };
    BathroomInfoCollapseWidget.prototype.bathroomInfoCollapseLabel = function () {
        var headerElement = React.createElement("label", { className: "ml-2" }, "How many bathrooms are in the property?");
        var contentElement = React.createElement("div", { className: "card col-md-6 shadow-none" },
            React.createElement("div", { className: "card-body" },
                React.createElement("p", { className: "card-text" },
                    "Please include en-suites, shower or wet rooms, and rooms with just a toilet and basin. ",
                    ' ',
                    "You don't need to tell us about sinks in utility rooms, laundry rooms or kitchens.")));
        return (React.createElement("div", { className: "bathroom-collapse-label-widget" },
            React.createElement(CollapseHtmlWithInfoIconWidget_1.CollapseHtmlWithInfoIconWidget, { header: headerElement, content: contentElement, parentCallback: this.bathroomInfoCallback })));
    };
    return BathroomInfoCollapseWidget;
}(React.Component));
exports.BathroomInfoCollapseWidget = BathroomInfoCollapseWidget;
//# sourceMappingURL=BathroomInfoCollapseWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/BathroomInfoCollapseWidget.js
// module id = 2554
// module chunks = 0